export enum Granularities {
  Yearly = 'YEARLY',
}
